import { useCallback, useRef } from 'react';

import { useAutoScroll } from '@/components/livekit/livekit/scroll-area/hooks/useAutoScroll';

import { cn } from '@/lib/utils';

interface ScrollAreaProps {
  children?: React.ReactNode;
  className?: string;
}

export const ScrollArea = function ScrollArea({
  ref,
  className,
  children,
}: ScrollAreaProps & { ref?: React.RefObject<HTMLDivElement | null> }) {
  const scrollContentRef = useRef<HTMLDivElement>(null);

  useAutoScroll(scrollContentRef.current);

  const mergedRef = useCallback(
    (node: HTMLDivElement | null) => {
      scrollContentRef.current = node;

      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    },
    [ref]
  );

  return (
    <div ref={mergedRef} className={cn('overflow-y-scroll scroll-smooth', className)}>
      <div>{children}</div>
    </div>
  );
};
